import { useEffect, useState } from "react";
import styles from "./Loader.module.scss";
import tickImage from "../../../assets/images/RightIcon.svg";

function SuccessLoader({ onProgress }) {
  const [progress, setProgress] = useState(0);

  const progressSteps = [0, 50, 75, 100, 101];

  useEffect(() => {
    let index = 0;

    const interval = setInterval(() => {
      index++;

      if (index >= progressSteps.length) {
        clearInterval(interval);
      } else {
        const nextValue = progressSteps[index];
        setProgress(nextValue);

        // ✅ send progress to parent
        if (onProgress) {
          onProgress(nextValue);
        }
      }
    }, 1000);

    return () => clearInterval(interval);
  }, []);

  return (
    <div className={styles.loaderWrapper}>
      {progress === 101 ? (
        <>
          <div className={styles.spinner1}></div>
          <img
            src={tickImage}
            alt="Completed"
            className={styles.percentageText}
          />
        </>
      ) : (
        <>
          <div className={styles.spinner}></div>
          <div className={styles.percentageText}>
            {progress}%
          </div>
        </>
      )}
    </div>
  );
}

export default SuccessLoader;